import React, { useCallback, useEffect, useState } from 'react';
import { Platform, View } from 'react-native';
import { MasonryFlashList } from '@shopify/flash-list';
import { useCollectionItemQuery } from '@annunciate/query';
import { DisplayMode, } from '@annunciate/core';
import { COLLECTION_ITEMS } from '../../../utils/mocks';
import { TileItem } from './TileItem';
import { useWindowWidth } from '../../..';
import { CollectionHero } from './CollectionHero';
import { TileContainer } from './TileContainer';
export const Tile = ({ collection, }) => {
    const { isFetchingNextPage, isFetchingPreviousPage, hasNextPage, data, fetchNextPage, } = useCollectionItemQuery({
        parentId: collection.id,
        displayMode: DisplayMode.TILED,
        shouldObserveUser: collection.isUserDependent,
    });
    const screenWidth = useWindowWidth();
    const [numColumns, setNumColumns] = useState(1);
    const isHeroDisplayed = collection?.displayConfig?.displayHero;
    const isLoadingPage = isFetchingNextPage || isFetchingPreviousPage;
    useEffect(() => {
        if (screenWidth > 1800) {
            setNumColumns(6);
        }
        else if (screenWidth > 1300) {
            setNumColumns(5);
        }
        else if (screenWidth > 1000) {
            setNumColumns(4);
        }
        else if (screenWidth > 600) {
            setNumColumns(2);
        }
        else {
            setNumColumns(1);
        }
    }, [screenWidth]);
    const onEndReached = useCallback(() => {
        if (hasNextPage)
            fetchNextPage();
    }, [hasNextPage, fetchNextPage]);
    let items = data;
    if (data.length === 0) {
        items = COLLECTION_ITEMS;
    }
    else if (isLoadingPage) {
        items = [
            ...data,
            COLLECTION_ITEMS[1],
        ];
    }
    ;
    let carousel = undefined;
    if (items[0]?.item?.__typename === 'Carousel') {
        carousel = items.shift();
    }
    const padding = 14;
    const itemDimension = (screenWidth / numColumns) - (padding * (Platform.OS === 'web' ? 1 : 0));
    return (React.createElement(TileContainer, null,
        React.createElement(MasonryFlashList, { numColumns: numColumns, data: items, estimatedItemSize: itemDimension, renderItem: ({ item, index }) => (React.createElement(TileItem, { index: index, item: item, widthConstraint: itemDimension, padding: padding })), onEndReachedThreshold: 0.15, onEndReached: onEndReached, ListHeaderComponent: isHeroDisplayed === true ? (React.createElement(View, null, collection.cover && (React.createElement(CollectionHero, { uri: collection.cover.src, collection: collection })))) : (carousel ? (React.createElement(TileItem, { index: -1, item: carousel, widthConstraint: screenWidth })) : undefined) })));
};
//# sourceMappingURL=Tile.js.map